const URL_API =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3015'
    : 'https://change.rud.com.ua:3010'

export {URL_API}
